import React, { FC, FormEvent } from "react";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";

import { useInput } from "~/hooks";

import { useApisManagersBusinessDivisionsCreate } from "../hooks/useApisManagersBusinessDivisionsCreate";

import { Form, FormSubmitButton, LabelWithTextField } from "~/ui";

export const BusinessDivisionNewForm: FC = () => {
  const navigate = useNavigate();

  const [
    { value: businessDivisionName, onChange: onChangeBusinessDivisionName },
  ] = useInput("");

  const { mutate, isLoading: isSubmitting } =
    useApisManagersBusinessDivisionsCreate();

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const body = { name: businessDivisionName };
    mutate(
      {
        body,
      },
      {
        onSuccess: (res) => {
          navigate("/managers/business_divisions");
          toast(res.message);
        },
      },
    );
  };

  return (
    <Form onSubmit={handleSubmit} className="space-y-6">
      <LabelWithTextField
        labelText="部署名"
        type="text"
        name="businessDivision"
        required
        placeholder="部署名"
        value={businessDivisionName}
        onChange={onChangeBusinessDivisionName}
      />
      <FormSubmitButton
        color="primary"
        className="w-full"
        value="保存"
        isReadOnly={isSubmitting}
      />
    </Form>
  );
};
